import { useQuery } from '@tanstack/react-query';

import { CMSPageTitleType } from '@/types/entities/cms.entities';

import { fetchCmsContentByType } from '../requests/cms.requests';

export const useFetchCmsContentByType = (pageTitle: CMSPageTitleType) =>
  useQuery({
    queryKey: ['cms', pageTitle],
    queryFn: async () => {
      try {
        const res = await fetchCmsContentByType(pageTitle);
        return res.data;
      } catch (error) {
        // Silently handle CMS fetch errors for public pages
        // Return empty data structure to prevent crashes
        return { cmsPage: { pageData: null } };
      }
    },
    enabled: !!pageTitle,
    retry: 0, // Don't retry for public pages to avoid multiple 401 errors
    // Fallback data to prevent crashes
    placeholderData: { cmsPage: { pageData: null } },
  });
